import { render, staticRenderFns } from "./class-progress-report.vue?vue&type=template&id=375ac0a5&scoped=true"
import script from "./class-progress-report.ts?vue&type=script&lang=ts&external"
export * from "./class-progress-report.ts?vue&type=script&lang=ts&external"
import style0 from "./class-progress-report.scss?vue&type=style&index=0&id=375ac0a5&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375ac0a5",
  null
  
)

export default component.exports